import React, { Fragment } from "react";
import TranslatedKey from "./TranslatedKey";

const ConfiguratorSurveyOutputRender = ({
  title,
  description,
  image_filename,
  output_thickness,
  children,
  simpleOutput,
  realtime,
  output_type,
  hidden_question,
  role
}) => {

  const thickness =
    output_thickness <= 1
      ? 'slim'
      : (
        output_thickness >= 3
          ? 'thick'
          : 'normal'
      );
  const thicknessMappings = {
    realtimeSummary: {
      slim: 'text-sm',  // default
      normal: 'text-md',
      thick: 'text-xl',
    },
    finalSummary: {
      slim: 'text-xl',
      normal: 'text-3xl',
      thick: 'text-4xl',
    },
  }
  const isSlim = thickness === 'slim';

  const titleCls = thicknessMappings[realtime ? 'realtimeSummary' : 'finalSummary'][thickness];

  const imageSize =
    realtime || isSlim
      ? { minWidth: "3.5rem", height: "3.5rem" }
      : { minWidth: "5rem", height: "5rem" };

  const boxStyle = realtime ? "py-1" : (isSlim ? "py-1 mb-1" : "py-4");

  const isLink = output_type === "link";

  const isHidden = hidden_question?.length && hidden_question.indexOf(`role_type_${role}`) >= 0;

  return (
    <div className={`flex justify-between w-full items-center ${boxStyle} ${isHidden ? "hidden" : ""}`}>
      <div className={`flex items-center`}>
        {image_filename && !isSlim && !simpleOutput && !realtime ? (
          <div
            className={`bg-cover bg-center relative`}
            style={{
              backgroundImage: `url(${"/" + image_filename})`,
              ...imageSize,
            }}
          />
        ) : null}

        <div className="flex flex-col w-full pr-10">
          {isLink ? (
            <a
              href={description}
              target="_blank"
              className="cursor-pointer underline text-am-500 hover:text-am-700"
              rel="noreferrer"
            >
              <p className={realtime ? "text-md" : "text-base"}>{title}</p>
            </a>
          ) : (
            <Fragment>
              {title ? (
                <div className="flex items-center">
                  <div>
                    <h2 className={`${titleCls} leading-none`}>
                      <TranslatedKey id={title} />
                    </h2>
                  </div>
                </div>
              ) : null}
              {description && !isSlim ? (
                <div>
                  <p className={realtime ? "mt-2 text-xs" : "mt-2 text-base"}>
                    <TranslatedKey id={description} />
                  </p>
                </div>
              ) : null}
            </Fragment>
          )}
        </div>
      </div>
      {image_filename && simpleOutput ? (
        <div
          className={`bg-cover bg-center relative`}
          style={{
            backgroundImage: `url(${"/" + image_filename})`,
            ...imageSize,
          }}
        />
      ) : null}
      {children}
    </div>
  );
};

export default ConfiguratorSurveyOutputRender;
